// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Buildings, Flag, ShieldSecurity } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  development: Buildings,
  special: ShieldSecurity,
  international: Flag
};

// ==============================|| MENU ITEMS - DEVELOPMENT ||============================== //

const development: NavItemType = {
  id: 'development-group',
  title: <FormattedMessage id="common.menu.developments.group" />,
  type: 'group',
  children: [
    // {
    //   id: 'development',
    //   title: <FormattedMessage id="common.menu.developments.developments" />,
    //   type: 'collapse',
    //   icon: icons.development,
    //   children: [
    //     {
    //       id: 'development-card',
    //       title: <FormattedMessage id="common.menu.developments.cards" />,
    //       type: 'item',
    //       url: '/developments',
    //       chip: {
    //         label: <FormattedMessage id="search.map.map" />,
    //         color: 'info',
    //         size: 'small',
    //         variant: 'outlined'
    //       }
    //     },
    //     {
    //       id: 'development-list',
    //       title: <FormattedMessage id="common.menu.developments.list" />,
    //       type: 'item',
    //       url: '/developments/list',
    //       chip: {
    //         label: 'beta',
    //         color: 'info',
    //         size: 'small',
    //         variant: 'outlined'
    //       }
    //     }
    //   ]
    // },
    {
      id: 'development-card',
      title: <FormattedMessage id="common.menu.developments.developments" />,
      type: 'item',
      url: '/developments',
      icon: icons.development,
      chip: {
        label: <FormattedMessage id="search.map.map" />,
        color: 'info',
        size: 'small',
        variant: 'outlined'
      }
    },
    {
      id: 'development-special',
      title: <FormattedMessage id="specDevCompanies.common.title" />,
      url: '/developments/special',
      type: 'item',
      icon: icons.special
    },
    {
      id: 'development-international',
      title: <FormattedMessage id="internationalDevelopments.title" />,
      url: '/developments/international',
      type: 'item',
      icon: icons.international
    }
  ]
};

export default development;
